/*
 * 模块: Sidebar
 * 职责: 侧边导航栏组件（可折叠、分组）
 * 依赖: antd, react-router-dom
 * 导出: Sidebar
 * 限制: 文件<280行
 */

import React, { useState } from 'react';
import { Layout, Menu } from 'antd';
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  HomeOutlined,
} from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import type { MenuProps } from 'antd';
import { useAuth } from '../../contexts/AuthContext';
import { SIDEBAR_MENU_ITEMS, ROUTE_MAP, getSelectedKey } from './SidebarConfig';
import './Sidebar.css';

const { Sider } = Layout;

/**
 * 侧边导航栏
 */
export const Sidebar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const { user } = useAuth();

  // 只有超级管理员可以看到 AI 提示语管理、配置管理中心、指标说明
  const filteredMenuItems = (SIDEBAR_MENU_ITEMS || []).filter(item => {
    if (item && (item.key === 'prompt-management' || item.key === 'config-manager' || item.key === 'metrics-guide')) {
      return user?.is_superuser || user?.username === 'admin';
    }
    return true;
  });

  /**
   * 处理菜单点击
   */
  const handleMenuClick: MenuProps['onClick'] = ({ key }) => {
    if (ROUTE_MAP[key]) {
      navigate(ROUTE_MAP[key]);
    }
  };

  return (
    <Sider
      collapsible
      collapsed={collapsed}
      onCollapse={setCollapsed}
      width={200}
      collapsedWidth={80}
      className="app-sidebar"
      trigger={null}
    >
      {/* 菜单 */}
      <Menu
        mode="inline"
        selectedKeys={[getSelectedKey(location.pathname, location.search)]}
        onClick={handleMenuClick}
        items={filteredMenuItems}
        className="sidebar-menu"
      />

      {/* 折叠按钮 - 移到底部 */}
      <div className="sidebar-trigger" onClick={() => setCollapsed(!collapsed)}>
        {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
      </div>
    </Sider>
  );
};

export default Sidebar;
